// components/PreistCartItemCard.jsx
import React from 'react';
import styles from './Presistcartitem.module.css';
import trashicon from "../../assets/images/icon/trashicon.png"
import { CheckBox } from '@mui/icons-material';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useState } from 'react';
import { ShowDialogForPayment } from '../eventComponent/EventTabs/showdialogforpayment';
const PreistCartItemCard = ({
  eventId,
  eventname,
  data = [],
  serviceType = 'priestData',
  refreshCart,
  removeItem,
  eventtitle,
  onPriestSelect,
  selectedcartitem,
  refundpreistfromcart,
  openRefundDialog,
}) => {
  const now = new Date();
  // console.log("preistdata",data,eventId,eventname)

  const [showDialog, setShowDialog] = React.useState(false);
  const { is_edit_allowed, paid_amount, gstAmount, gstPercentage, totalAmount, is_checked_out, balance_to_be_paid,
    is_cancel_in_progress,
    is_canceled,
    refund_complete,
    refund_in_pending,
    refunded_amount,
  } = data[0];

  const [showdeleteoverlay, setshowdeleteoverlay] = useState(false)
  const selectedAmount = selectedcartitem
    .find((p) => p.eventid === eventId)
    ?.services["priest"]
    ?.find((pd) => pd.id === data[0].provider_id)?.total;

  const addGST = (amount) => {
    return Math.round(amount + gstAmount);
  };
  const getFinalPrice = (item) => {
    const validUpto = new Date(item.validUpto);
    if (!isNaN(validUpto) && now < validUpto && item.discountPrice > 0) {
      return addGST(item.discountPrice);
    }
    return addGST(item.price);
  };
  const handleRemove = async (cartId) => {
    try {

      await removeItem(cartId, eventId);
      refreshCart();
      window.scrollTo({ top: 0 });
    } catch (error) {
      console.error('Failed to remove priest item:', error);
    }
  };
  const priestCartItems = is_edit_allowed
    ? data?.map((item) => {
      const quantity = item.quantity ?? 1;
      const finalPrice = getFinalPrice(item); // your discount logic
      const total = quantity * finalPrice;
      return {
        id: item.provider_id,
        cartid: item.cart_id,
        quantity,
        price: finalPrice,
        total,
      };
    }) || []
    : [
      {
        id: data?.[0]?.provider_id,
        cartid: data?.[0]?.cart_id,
        quantity: 1,
        price: balance_to_be_paid,
        total: balance_to_be_paid,
      },
    ];
  const [showcancelationconfirmation, setshowcancelationconfirmation] = useState(false)
  const deletepaidamount = async () => {

    try {
      const response = await refundpreistfromcart(parseInt(eventId), data[0].provider_id)

      refreshCart();
      openRefundDialog(["priest"]);
      setshowcancelationconfirmation(true);
    } catch (error) {

    }
    finally {
      setshowdeleteoverlay(false)
    }
  }
  // Add this function after your helper functions
  const basegrandtotal = priestCartItems.reduce((sum, item) => sum + item.total, 0);
  const priestGrandTotal = priestCartItems.length > 0
    ? (priestCartItems[0].total)
    : 0;


  return (
    <div className={styles.cartItemWrapper}>

      {data.map((item, idx) => {
        const quantity = item.quantity ?? 1;
        const finalPrice = getFinalPrice(item);
        const originalPrice = (item.price);
        const isvalid = new Date(item.validUpto) > new Date();
        return (
          <div key={idx} className={styles.cartItem}>
            <span
              style={{
                display: "flex",
                fontSize: "24px",
                gap: "10px",
                fontWeight: "600",
                width: "100%",
                justifyContent: "space-between", // <-- this moves content to ends
                alignItems: "center",
              }}
            >
              {/* Left side: Priest + Price */}
              <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                Priest
                {finalPrice !== originalPrice && (isvalid) ? (
                  <div className={styles.pricevalue}>
                    <span style={{ fontSize: "24px" }} className={styles.originalPrice}>
                      ₹{originalPrice}
                    </span>
                    <span style={{ fontSize: "24px" }} className={styles.discountedPrice}>
                      ₹{finalPrice}
                    </span>
                  </div>
                ) : (
                  <span style={{ fontSize: "24px" }} className={styles.regularPrice}>
                    ₹{originalPrice}
                  </span>
                )}
              </span>

              {/* Right side: Status */}
              {(is_cancel_in_progress || is_canceled) && (
                <span style={{ color: "red", fontSize: "16px" }}>
                  Status{" Cancelled payment"}
                  {is_cancel_in_progress && <span> In progress</span>}{" "}
                  {is_canceled && <span>Canceled</span>}
                </span>
              )}
            </span>

            <div className={styles.cartBodyInner}>
              {/* <div className={styles.cartPic} /> */}
              <div className={styles.cartData}>
                <div className={styles.cartpreistdetails}>
                  <div className={styles.cartName}>
                    {item.providername || 'Priest'}

                  </div>
                  {/* <div className={styles.eventtitleforpreist}>
                {eventtitle?eventtitle:""}
                </div> */}
                </div>
                {((paid_amount == 0) && is_canceled !== true) &&
                  (<div className={styles.removeblock}>
                    <div className={styles.removeborder} onClick={() => handleRemove(item.cart_id)}>
                      <img style={{ display: "flex", width: "16px", height: "18px", justifyContent: "center", marginRight: "6px" }} src={trashicon} alt='trashicon' />
                      <button
                        className={styles.removeBtn}
                        onClick={() => handleRemove(item.cart_id)}
                      >

                        Remove
                      </button>
                    </div>
                  </div>)
                }
                {/* <div className={styles.cartDetails}>Qty: {quantity}</div> */}
                {/* cancle payment */}
                {(paid_amount > 0) && (!is_cancel_in_progress && !is_canceled) &&
                  <div className={styles.deletepayment} onClick={() => setshowdeleteoverlay(true)}>
                    <i className="pi pi-times" style={{ color: 'red' }}></i>
                    <button
                      className={styles.removeBtn}
                      onClick={() => setshowdeleteoverlay(true)}
                    >
                      Cancel payment
                    </button>
                  </div>
                }

              </div>
              <div className={styles.priceDetails}>

                {/* {(!is_cancel_in_progress && !is_canceled) &&
                  
                } */}

                {/* <div className={styles.pricechoosing}>

                    <div className={styles.priceheadder}>Pay In Advance</div>
                    <div className={styles.optionsforprice}>
                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-priest-${eventId}-${data[0]?.provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some((pd) => {
                                const match = pd.id === data[0].provider_id && pd.total === priestGrandTotal;
                                console.log("CHECKED? Total", { pd, priestGrandTotal, match });
                                return match;
                              })}
                          onClick={(e) => {
                            const isAlreadySelected = !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === priestGrandTotal
                              );

                            if (isAlreadySelected) {
                              // Uncheck (remove from cart)
                              onPriestSelect(eventId, "priest", false, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal,
                              });
                              e.target.checked = false; // force uncheck
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.checked) {
                              onPriestSelect(eventId, "priest", true, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal,
                              });
                            }
                          }}
                        />
                        Total Amount
                      </label>

                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-priest-${eventId}-${data[0]?.provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some((pd) => {
                                const match = pd.id === data[0].provider_id && pd.total === priestGrandTotal * 0.5;
                                console.log("CHECKED? 50%", { pd, half: priestGrandTotal * 0.5, match });
                                return match;
                              })}
                          onClick={(e) => {
                            const isAlreadySelected = !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === priestGrandTotal * 0.5
                              );

                            if (isAlreadySelected) {
                              onPriestSelect(eventId, "priest", false, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal * 0.5,
                              });
                              e.target.checked = false;
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.checked) {
                              onPriestSelect(eventId, "priest", true, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal * 0.5,
                              });
                            }
                          }}
                        />
                        50%
                      </label>
                      <label className={styles.priceoptions}>
                        <input
                          type="radio"
                          name={`payment-priest-${eventId}-${data[0]?.provider_id}`}
                          checked={
                            !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some((pd) => {
                                const match = pd.id === data[0].provider_id && pd.total === priestGrandTotal * 0.25;
                                console.log("CHECKED? 25%", { pd, quarter: priestGrandTotal * 0.25, match });
                                return match;
                              })}
                          onClick={(e) => {
                            const isAlreadySelected = !!selectedcartitem
                              .find((p) => p.eventid === eventId)
                              ?.services["priest"]?.some(
                                (pd) => pd.id === data[0].provider_id && pd.total === priestGrandTotal * 0.25
                              );

                            if (isAlreadySelected) {
                              onPriestSelect(eventId, "priest", false, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal * 0.25,
                              });
                              e.target.checked = false;
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.checked) {
                              onPriestSelect(eventId, "priest", true, {
                                id: data[0].provider_id,
                                cartid: data[0].cart_id,
                                total: priestGrandTotal * 0.25,
                              });
                            }
                          }}
                        />
                        25%
                      </label>
                    </div>

                  </div> */}

                <div className={styles.priceDetails}>
                  <div className={styles.priceDetails}>
                    <span className={styles.priceLabel}>Total: <span style={{ fontWeight: "600" }}>₹{item.price}</span> </span>
                    <span className={styles.priceLabel} style={{ color: "#666" }}>Taxes: <span style={{ fontWeight: "600", color: "#666" }}>₹{item.gstAmount}</span> </span>

                    <div style={{ borderTop: "1px solid #ddd", borderBottom: "1px solid #ddd", padding: "8px 0", margin: "8px 0" }}>
                      <span className={styles.priceLabel}>Sub Total: <span style={{ fontWeight: "600" }}>₹{item.totalAmount}</span> </span>
                    </div>
                  </div>

                  <div style={{ marginTop: "16px" }}>
                    <span className={styles.priceLabel}>Paid Amount: <span style={{ fontWeight: "600" }}>₹{paid_amount}</span> </span>
                  </div>

                  <span className={styles.regularPrice}>
                    <span>Balance to be paid:</span>
                    {!isNaN(balance_to_be_paid) && balance_to_be_paid > 0 ? (
                      <>
                        <span style={{ fontWeight: "600" }}>₹{balance_to_be_paid}</span>
                      </>
                    ) : (
                      <>
                        <span style={{ fontWeight: "600" }}>₹{item.totalAmount}</span>
                      </>
                    )}
                  </span>

                  <div>
                    {selectedAmount && (
                      <div>
                        {/* <p style={{ fontWeight: "bold", marginTop: "10px" }}>
          To Pay<s>₹{service.quantity * service.price}</s>
          ₹{selectedAmount} <span style={{ fontSize: "14px", color: "#666" }}>(incl. GST) %</span>
        </p> */}
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
            <Dialog
              visible={showdeleteoverlay}
              onHide={() => setshowdeleteoverlay(false)}
              header="Confirm Delete"
              footer={
                <div className="flex justify-end gap-2">
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => setshowdeleteoverlay(false)}
                    className="p-button-text"
                  />
                  <Button
                    label="Delete"
                    icon="pi pi-check"
                    severity="danger"
                    onClick={deletepaidamount}
                    autoFocus
                  />
                </div>
              }
            >
              <span>Are you sure you want to delete the paid priest?</span>
            </Dialog>

            <Dialog
              visible={showcancelationconfirmation}
              onHide={() => setshowcancelationconfirmation(false)}
              header="Confirmed Delete"
              footer={
                <div className="flex justify-end gap-2">
                  <Button
                    label="Okay"
                    icon="pi pi-times"
                    onClick={() => setshowcancelationconfirmation(false)}
                    className="p-button-text"
                  />

                </div>
              }
            >
              <span>You will get your amount back in some days</span>
            </Dialog>
            <ShowDialogForPayment
              refundItems={["Priest"]}
              showDialog={showDialog}
              setShowDialog={setShowDialog}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PreistCartItemCard;
